import { Directive, HostListener } from '@angular/core'

@Directive({
  standalone: true,
  selector: '[appDisallowQuotes]',
})
export class DisallowQuotesDirective {
  @HostListener('input', ['$event'])
  onInput(event: Event): void {
    const inputElement = event.target as HTMLInputElement
    const filteredValue = inputElement.value.replace(/['"]/g, '')

    if (inputElement.value !== filteredValue) {
      inputElement.value = filteredValue
      event.preventDefault()
    }
  }

  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent): void {
    if (event.key === "'" || event.key === '"') {
      event.preventDefault()
    }
  }
}
